import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getEmailGroups = async () => {
  const response = await axiosInstance.get(`${API_URL}/email-groups`);
  return response.data;
};

export const getEmailGroupById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/email-groups/${id}`);
  return response.data;
};

export const createEmailGroup = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/email-groups`, payload);
  return response.data;
};

export const updateEmailGroup = async (id, payload) => {
  const response = await axiosInstance.put(`${API_URL}/email-groups/${id}`, payload);
  return response.data;
};

export const deleteEmailGroup = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/email-groups/${id}`);
  return response.data;
};
